<template>
    <div :class='{ "high-contrast":highContrast,"left":floatLeft }'
         class="filter-bar block text-center sm:text-left flex flex-row gap-2">
        <a @click.prevent="toggleFilter(null)"
           v-if="!hideAll"
           :class="[
               textSize,
               chosenFilters.length === 0 ? 'bg-brand text-white' : backgroundClass+' text-brand'
            ]"
           class="rounded hover:bg-brand hover:text-white px-4 py-2 font-medium" href="#">All</a>
        <a v-for="(filterLabel,filterValue) in filters" @click.prevent="toggleFilter(filterValue)"
           :class="[
               textSize,
               filterIsActive(filterValue) ? 'bg-brand text-white' : backgroundClass+' text-brand'
            ]"
           class="rounded hover:bg-brand hover:text-white px-4 py-2 font-medium"
           href="#">{{ filterLabel }}</a>
    </div>
</template>

<script>
    export default {
        props: [
            'canBeDeactivated',
            'filters',
            'highContrast',
            'size',
            'hideAll',
            'floatLeft',
            'doNotListenToFilterChangeEvents',
            'initialFilter',
            'multiple'
        ],
        data() {
            return {
                chosenFilters: [],
                showAllFilters: true
            }
        },
        computed: {
            textSize() {
                if (this.size === 'small') {
                    return 'text-xs'
                }
                return 'text-sm'
            },
            backgroundClass() {
                if (this.highContrast) {
                    return 'bg-white'
                }

                return 'bg-gray-50'
            }
        },
        watch: {
            chosenFilters: function (value) {
                this.showAllFilters = false;
            },
            filters: function(filters){
                window.eventBus.$emit('filter-bar-set-filters',filters,this.hideAll);
            }
        },
        methods: {
            filterIsActive: function(filterName){
              return this.chosenFilters.includes(filterName);
            },
            toggleFilter: function (filterName) {
                this.addFilter(filterName);
                eventBus.$emit('filter-bar-changed', filterName,this.filters[filterName]);
                this.$emit('change', this.chosenFilters)
            },
            toggleFilters: function () {
                this.showAllFilters = !this.showAllFilters;
            },
            isEmptyFilterName(filterName){
              if(_.isNull(filterName)){
                return true;
              }

              if(_.isEmpty(filterName)){
                return true;
              }

              if(filterName == ''){
                return true;
              }

              return false
            },
            addFilter(filterName){
              if(!this.multiple){
                if(this.isEmptyFilterName(filterName)){
                  this.chosenFilters = []
                }else{
                  this.chosenFilters = [filterName]
                }

                return
              }

              if(this.isEmptyFilterName(filterName)){
                return
              }

              if(this.filterIsActive(filterName)){
                this.chosenFilters = this.chosenFilters.filter(function(chosenFilter){
                  return chosenFilter !== filterName
                })
              }else{
                this.chosenFilters.push(filterName)
              }
            }
        },
        mounted() {
            var that = this;

            this.addFilter(this.initialFilter)

            if(!this.doNotListenToFilterChangeEvents){
                eventBus.$on('filter-bar-changed', function (filterName) {
                    that.addFilter(filterName);
                    that.showAllFilters = false;
                });
            }

            window.eventBus.$emit('filter-bar-set-filters',this.filters,this.hideAll);
        }
    }
</script>
